import React from "react";
import { Navigation, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";
import LocalizedLink from "../LocalizedLink/LocalizedLink";
import hero1 from "../../images/slider/slide-1.jpg";
import hero2 from "../../images/slider/slide-2.jpg";
import { AnimatedOnScroll } from "react-animated-css-onscroll";

const Hero = () => {
  const { t } = useTranslation("home");

  return (
    <section className="hero-slider hero-style-1 ">
      <Swiper
        modules={[Navigation, A11y]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        speed={1800}
        parallax={true}
        navigation
      >
        <SwiperSlide>
          <div
            className="slide-inner slide-bg-image"
            style={{ backgroundImage: `url(${hero1})` }}
          >
            <div className="container-fluid">
              <div className="slide-content">
                <AnimatedOnScroll animationIn="fadeInUp">
                  <div className="slide-title">
                    <h1>{t("hero.slide1.title")}</h1>
                  </div>
                  <div className="slide-text">
                    <p>{t("hero.slide1.subtitle")}</p>
                  </div>
                  <div className="clearfix"></div>
                  <div className="slide-btns">
                    <LocalizedLink to="/about" className="theme-btn">
                      {t("hero.discover")}<span></span>
                    </LocalizedLink>
                  </div>
                </AnimatedOnScroll>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            className="slide-inner slide-bg-image"
            style={{ backgroundImage: `url(${hero2})` }}
          >
            <div className="container-fluid">
              <div className="slide-content">
                <AnimatedOnScroll animationIn="fadeInUp">
                  <div className="slide-title">
                    <h2>{t("hero.slide2.title")}</h2>
                  </div>
                  <div className="slide-text">
                    <p>{t("hero.slide2.subtitle")}</p>
                  </div>
                  <div className="clearfix"></div>
                  <div className="slide-btns">
                    <LocalizedLink to="/about" className="theme-btn">
                      {t("hero.discover")}<span></span>
                    </LocalizedLink>
                  </div>
                </AnimatedOnScroll>
              </div>
            </div>
          </div>
        </SwiperSlide>
        ...
      </Swiper>
    </section>
  );
};

export default Hero;
